export const getMissingTicketNumbers = (state) => {
  return state.missingTicketNumbers;
};

export const getViewMissing = (state) => {
  const { viewMissing } = getMissingTicketNumbers(state);
  return viewMissing;
};

export const getViewNotExpected = (state) => {
  const { viewNotExpected } = getMissingTicketNumbers(state);
  return viewNotExpected;
};

export const getSelectedMissingTicketNumberId = (state) => {
  const { selectedMissingTicketNumberId } = getMissingTicketNumbers(state);
  return selectedMissingTicketNumberId;
};
